"use strict";
export const QUEUES = [
  "new",
  "indexing",
  "ready-to-audit",
  "exceptions",
  "replies",
  "waiting",
  "verify",
  "review",
  "review-test",
  "processed"
];
export const FILTER_PARAMS = [
  "customers",
  "selectedLabelFilters",
  "negatedLabelFilters",
  "categories",
  "startDate",
  "endDate",
  "startDateTime",
  "endDateTime",
  "rangeType",
  "sort",
  "exceptions"
];
function isFilterParam(key) {
  return FILTER_PARAMS.includes(key) || key.startsWith("filters[");
}
function isDashboardPath(pathname) {
  return /^(\/app)?\/dashboard/.test(pathname);
}
function queueFromPath(pathname) {
  const queue2 = pathname.replace(/^(\/app)?\/dashboard\/?/, "");
  return QUEUES.includes(queue2) ? queue2 : "";
}
function dashboardModeFrom(search) {
  return new URLSearchParams(search).get("dashboardMode") || "";
}
function filterPairs(search) {
  return search.replace(/^\?/, "").split("&").filter((pair) => isFilterParam(decodeURIComponent(pair.split("=")[0])));
}
function filterString(search) {
  return filterPairs(search).join("&");
}
function onDoneUrl(search) {
  const onDone = new URLSearchParams(search).get("onDone");
  if (!onDone || !isDashboardPath(onDone.split("?")[0])) return "";
  return onDone;
}
function queueFromUrl(url) {
  const [pathname, search] = url.split("?");
  const queue2 = queueFromPath(pathname);
  if (!queue2) return null;
  return { queue: queue2, dashboardMode: dashboardModeFrom(search || "") };
}
function filters() {
  if (isDashboardPath(window.location.pathname)) {
    const live = filterString(window.location.search);
    if (live) return live;
  }
  const onDoneSearch = onDoneUrl(window.location.search).split("?")[1];
  return onDoneSearch ? filterString(onDoneSearch) : "";
}
function queue() {
  if (isDashboardPath(window.location.pathname)) {
    const live = queueFromUrl(
      window.location.pathname + window.location.search
    );
    if (live) return live;
  }
  return queueFromUrl(onDoneUrl(window.location.search));
}
function queuePathFor(route, dashboardMode = "") {
  const [pathname, search] = route.split("?");
  if (!isDashboardPath(pathname)) return route;
  const current = queue();
  if (!current || current.dashboardMode !== dashboardMode) return route;
  const prefix = pathname.startsWith("/app") ? "/app/dashboard" : "/dashboard";
  const queuePath = `${prefix}/${current.queue}`;
  return search ? `${queuePath}?${search}` : queuePath;
}
function mergeInto(route, extraParams, pairs) {
  const [pathname, routeSearch] = route.split("?");
  if (!isDashboardPath(pathname)) return route;
  const existingKeys = (routeSearch || "").split("&").filter(Boolean).map((pair) => decodeURIComponent(pair.split("=")[0]));
  const merged = (routeSearch ? routeSearch.split("&") : []).concat(
    pairs.filter(
      (pair) => !existingKeys.includes(decodeURIComponent(pair.split("=")[0]))
    )
  ).concat(
    Object.entries(extraParams).filter(([key]) => !existingKeys.includes(key)).map(([key, value]) => `${key}=${value}`)
  );
  return merged.length ? `${pathname}?${merged.join("&")}` : pathname;
}
function appendTo(route, extraParams = {}) {
  return mergeInto(route, extraParams, filterPairs(filters()));
}
function withParams(route, extraParams = {}) {
  return mergeInto(route, extraParams, []);
}
export default {
  filters,
  queue,
  queuePathFor,
  appendTo,
  withParams
};
